import {Blog, BlogCategory, BlogCategoryDetails} from "@/types";
import {default as allBlogs} from '@/content/blogs';

export const getAllBlogSlugs = () => {
    const slugs: string[] = [];

    Object.values(allBlogs).forEach((blogCategory: BlogCategoryDetails) => {
        blogCategory.blogs?.forEach((b: Blog) => {
            if (b.slug) {
                slugs.push(b.slug);
            }
        });
    });

    return slugs;
}

export const getCategoryBlogById = (id: number): BlogCategory => {
    return allBlogs[id];
}

export const getRelatedBlogsByCategory = (blog: Blog): Blog[] => {
    const blogCategory = blog.blogCategory?.id ? allBlogs[blog.blogCategory.id] : null;
    return blogCategory ? blogCategory?.blogs?.filter((b) => b.id !== blog.id) || [] : [];
}

export const generateBlogLink = (blogCategory: { categoryType: string; slug: string }, blog: {
    slug: string
}): { link: string; } => ({link: `${blogCategory.categoryType}/${blogCategory.slug}/${blog.slug}`});
